import React, { Props } from 'react';
import { Control, Controller, FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { TextField, Checkbox, Select, MenuItem, InputLabel, FormControl, FormHelperText } from '@mui/material';
import { Col, Container, Form, Row } from 'react-bootstrap'
import FormControlLabel from '@mui/material/FormControlLabel';
import { getHeading } from '../../utils/helper';

interface propTypes {
    name: string
    fieldOptions: {
        type: string,
        validations: {
            enum?: string[],
            required: boolean,
            length?: number
        }
    }
    control: any
    errors: any
    index: number
}


const FormsetInput: React.FC<propTypes> = ({
    name,
    fieldOptions,
    control,
    errors,
    index,
}: propTypes) => {
    const fieldname = name.split('.')[name.split('.').length - 1]

    if (fieldOptions.type === 'varchar') {
        return (
            <>
                <Controller
                    name={name}
                    rules={{
                        required: fieldOptions.validations.required ? "This field is required" : false,
                        maxLength: fieldOptions.validations.length
                    }}
                    defaultValue=""
                    control={control}
                    render={({ field: { value, ...field } }) => {
                        return (
                            <TextField
                                {...field}
                                type="text"
                                label={getHeading(fieldname)}
                                // inputRef={ref}
                                fullWidth
                                error={!!errors.formSets?.[index]?.[fieldname]}
                                helperText={errors.formSets?.[index]?.[fieldname] ?
                                    (errors.formSets?.[index]?.[fieldname]?.type === "maxLength" ?
                                        `Maximum length exceeded (${fieldOptions.validations.length} characters allowed)`
                                        : errors.formSets?.[index]?.[fieldname]?.type === "required" ?
                                            "This field is required" : errors.formSets?.[index]?.[fieldname]?.message)
                                    : ""}
                            />
                        )
                    }

                    }
                />
            </>
        );
    }
    else if (fieldOptions.type === 'int') {
        return (
            <>
                <Controller
                    name={name}
                    rules={{
                        required: fieldOptions.validations.required ? "This field is required" : false,
                    }}
                    defaultValue=""
                    control={control}
                    render={({ field: { ...field } }) =>
                        <TextField
                            {...field}
                            type="number"
                            InputProps={{
                                inputProps: { min: 0 } // Set min value if necessary
                            }}
                            InputLabelProps={{ shrink: true }}
                            label={getHeading(fieldname)}
                            // inputRef={ref}
                            fullWidth
                            error={!!errors.formSets?.[index]?.[fieldname]}
                            helperText={errors.formSets?.[index]?.[fieldname] ?
                                (errors.formSets?.[index]?.[fieldname]?.type === "required" ?
                                    "This field is required"
                                    : errors.formSets?.[index]?.[fieldname]?.message)
                                : ""}
                        />
                    }
                />
            </>
        );
    }
    else if (fieldOptions.type === 'boolean') {
        return (
            <>
                <Controller
                    name={name}
                    control={control}
                    defaultValue={false} // Default value for the checkbox
                    render={({ field: { ref, ...field } }) =>
                        <FormControlLabel
                            control={<Checkbox {...field} />}
                            label={getHeading(fieldname)}
                        />
                    }
                />
            </>
        );
    }
    else if (fieldOptions.type === 'enum') {
        return (
            <>
                <Controller
                    name={name} // name of the field
                    control={control} // control object from useForm
                    defaultValue="" // default value
                    rules={{
                        required: fieldOptions.validations.required ? "This field is required" : false,
                    }} // validation rules
                    render={({ field }) => (
                        <FormControl fullWidth>
                            <InputLabel id={`label_${name}`}>{getHeading(fieldname)}</InputLabel>
                            <Select
                                {...field}
                                labelId={`label_${name}`}
                                label={name}

                                variant="outlined"
                                fullWidth
                                error={!!errors.formSets?.[index]?.[fieldname]}
                            >
                                <MenuItem value="">Select an option</MenuItem>
                                {fieldOptions.validations.enum?.map((item: any, index) => (
                                    <MenuItem value={item.id}>{item.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                />
                {/* Error message */}

                {errors.formSets?.[index]?.[fieldname] ?
                    errors.formSets?.[index]?.[fieldname]?.type === "required" ?
                        <FormHelperText error>{errors.formSets?.[index]?.[fieldname]?.message}</FormHelperText>
                        : errors.formSets?.[index]?.[fieldname]?.message
                    : ""
                }

            </>
        );
    }
    else if (fieldOptions.type === 'date') {
        return (
            <>
                <Controller
                    name={name}
                    control={control}
                    defaultValue=""
                    rules={{
                        required: fieldOptions.validations.required ? "This field is required" : false,
                        pattern: {
                            value: /^\d{4}-\d{2}-\d{2}$/, // Validate the format (yyyy-MM-DD)
                            message: 'Invalid date format (yyyy-MM-DD)'
                        }
                    }}
                    render={({ field }) => (
                        <>
                            <TextField
                                {...field}
                                type="date"
                                label={getHeading(fieldname)}
                                variant="outlined"
                                error={!!errors.formSets?.[index]?.[fieldname]} // Set error state
                                InputLabelProps={{ shrink: true }} // Ensure the label doesn't overlap
                            />
                            {errors.formSets?.[index]?.[fieldname] ?
                                (errors.formSets?.[index]?.[fieldname]?.type === "required" ?
                                    <FormHelperText error>{errors.formSets?.[index]?.[fieldname]?.message}</FormHelperText>
                                    : errors.formSets?.[index]?.[fieldname]?.type === "pattern" ?
                                        <FormHelperText error>{errors.formSets?.[index]?.[fieldname]?.message}</FormHelperText>
                                        : "Error")
                                : ""
                            }
                        </>
                    )}
                />
            </>
        );
    }
    return <></>

};

export default FormsetInput;